import React from "react";
import OnboardingLayout from "./OnboardingLayout";
import erodeLogo from "../../assets/images/erode-logo-black.svg";
import { HiArrowRight } from "react-icons/hi";

// Props for the StepWelcome component interface.
interface StepWelcomeProps {
  onContinue?: () => void;
  hasExistingPersonas?: boolean;
  onExit?: () => void;
}

/**
 * Welcome step of the onboarding flow.
 */

// Renders a welcome message and a button to proceed to the next step.
function StepWelcome({ onContinue, hasExistingPersonas, onExit }: StepWelcomeProps) {
  return (
    <OnboardingLayout showLogo={false} hasExistingPersonas={hasExistingPersonas} onExit={onExit}>
      <div className="px-12 py-12 flex flex-col items-center text-center gap-6">
        {/* Erode logo at the top of the welcome step */}
        <img
          src={erodeLogo}
          alt="Erode"
          className="h-12 object-contain"
          draggable={false}
        />
        {/* Welcome message and introduction text */}
        <div className="space-y-3">
          <p className="text-base font-semibold text-eai-dark">
            Hi, I'm your forecasting assistant
          </p>
          <p className="text-base text-[#5b6f72] max-w-[380px] mx-auto">
            I can help you forecast snowpack and renewable generation, dig into
            historical weather and flows, and explain weather-dependent behavior
            across your markets.
          </p>
          <p className="text-base text-[#5b6f72]">
            First, let me get to know you...
          </p>
        </div>
        {/* Button to continue to the next step */}
        <button
          type="button"
          onClick={onContinue}
          className="mt-4 inline-flex items-center justify-center gap-2 rounded-lg bg-eai-primary-accent px-12 py-2.5 text-sm font-medium text-white transition hover:opacity-90"
        >
          Let's start
          <HiArrowRight />
        </button>
      </div>
    </OnboardingLayout>
  );
}

export default StepWelcome;
